<template>
    <div class="c-thumb-index__item" :class="append_class.item">
        <a :href="link" class="c-thumb-index__link" :class="class_link">
            <div class="c-thumb-index__thumb">
                <img :src="item.thumb" alt="" class="u-sz-w100" :class="append_class.image">
                <span class="c-thumb-index__badge" v-if="has_type">{{item.type}}</span>
            </div>
            <span class="c-thumb-index__title" v-html="item.title"></span>
        </a>
    </div>
</template>

<script>

const type_movie = 'Movie';

export default {
    props: {
        item: Object,
        // リンクURL。youtubeの場合はyoutube URL
        link: String,
        // 追加クラスが必要な場合
        append_class: Object
    },
    computed: {
        has_type() {
            return 'type' in this.item;
        },
        class_link() {
            const class_array = [this.append_class.link];

            // Youtube対応
            if (this.has_type && this.item.type === type_movie) {
                class_array.push('js-youtube');
                class_array.push('c-thumb-index__link_youtube');
            }
            return class_array;
        }
    }
};

</script>


// WEBPACK FOOTER //
// thumb-index-item.vue?78c6614d